var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStonfi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.9564 28.9813C25.2028 28.8181 25.544 28.9228 25.6451 29.1927L29.4762 39.4161C29.5994 39.7449 29.289 40.0719 28.9351 39.9861L14.8295 36.5673C14.4501 36.4753 14.3602 35.9989 14.682 35.7858L24.9564 28.9813Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.4304 26.7247C27.4127 26.6775 27.4037 26.6277 27.4037 26.5776V16.2741C27.4037 15.9827 27.1107 15.7732 26.8185 15.8558L14.7316 19.273C14.4395 19.3556 14.1465 19.1461 14.1465 18.8547V12.1958C14.1465 12.0597 14.2129 11.9314 14.3261 11.8489L30.0769 0.36593C30.2958 0.206337 30.6115 0.267275 30.7486 0.495592L40.2636 16.3415C40.331 16.4538 40.3428 16.5889 40.2958 16.7103L32.2849 37.4043C32.1371 37.7861 31.5717 37.7832 31.4282 37.3999L27.4304 26.7247Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1137 1.25901C10.1897 1.18775 10.2895 1.1442 10.3956 1.13592L24.9331 0.00162366C25.3872 -0.0338079 25.6088 0.519633 25.2462 0.783536L12.8552 9.8014C12.7405 9.88487 12.5913 9.91155 12.4528 9.87337L4.29328 7.62322C3.95766 7.53066 3.85101 7.12624 4.10057 6.89244L10.1137 1.25901Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M2.02185 9.88742C2.05661 9.62136 2.33167 9.44801 2.6009 9.52248L11.2485 11.9145C11.4436 11.9684 11.5778 12.1392 11.5778 12.3335V22.0181C11.5778 22.3096 11.8711 22.5191 12.1633 22.4363L24.1663 19.0343C24.4585 18.9515 24.7518 19.161 24.7518 19.4525V25.604C24.7518 25.7468 24.6786 25.8806 24.556 25.9622L11.0931 34.9145C10.9175 35.0313 10.6807 35.0156 10.5236 34.8769L0.146663 25.7115C0.0385817 25.6161 -0.0147187 25.4766 0.00352446 25.337L2.02185 9.88742Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStonfi);
export default __webpack_public_path__ + "static/media/stonfi.45b14b958daf3d144c82801ecad4f99d.svg";
export { ForwardRef as ReactComponent };